// @flow

import React, { Component } from 'react';
import Toggle from 'material-ui/Toggle';
import DatePicker from 'material-ui/DatePicker';
import Alert from 'react-s-alert';
import $ from 'jquery';

import App from './App.jsx';
import LeftRight from './LeftRight.jsx';

import {SIDEBAR_WIDTH, CLASSIC_WIDTH} from './consts.js';

import type {T_MapnikMethods} from './types.js';


import './css/MenuBook.css';


const {DateTimeFormat} = Intl;



type T_MenuBookProps = {
  app             : App,
  dir             : string,
  include_mav_book: boolean,
  include_mt_book : boolean,
  mapnik_method   : T_MapnikMethods,
  show_tree       : boolean,
  building_doc    : boolean
};



type T_MenuBookState = {
  left     : number,
  map_total: number,
  font_size: number,
  date1    : string,
  date2    : string
}



export default class MenuBook extends Component<T_MenuBookProps, T_MenuBookState> {
  change_include_mav_book: (ev: SyntheticEvent<*>, include_mav_book: boolean) => void;
  change_include_mt_book : (ev: SyntheticEvent<*>, include_mt_book : boolean) => void;
  change_mapnik_method   : (ev: SyntheticEvent<*>, mapnik_method   : boolean) => void;
  change_font_size       : (ev: SyntheticInputEvent<*>) => void;
  update_total           : () => void;
  start_book             : () => void;
  cancel                 : () => void;
  
  
  
  constructor(props: T_MenuBookProps) {
    super(props);
    
    this.state = {
      left     : 10,
      map_total: 0,
      font_size: 12,
      date1    : 'NO',
      date2    : 'NO'
    };
    
    this.change_include_mav_book = this.change_include_mav_book.bind(this);
    this.change_include_mt_book  = this.change_include_mt_book.bind(this);
    this.change_mapnik_method    = this.change_mapnik_method.bind(this);
    this.update_total            = this.update_total.bind(this);
    this.start_book              = this.start_book.bind(this);
    this.cancel                  = this.cancel.bind(this);
    this.change_font_size        = this.change_font_size.bind(this);
  }
  
  
  
  update_total = (): void => {
    if (this.props.app.tree != null) {
      const item_dir = this.props.app.tree.get_sub_dir(this.props.dir);
      
      if (item_dir != null) {
        this.setState({
          map_total: item_dir.total_screenshots(this.props.include_mav_book, this.props.include_mt_book)
        });
      }
    }
  };
  
  
  
  set_position(): void {
    const $bt = $('#bt_informe');
    
    if ($bt.length > 0) {
      this.setState({
        left: $bt.position().left + SIDEBAR_WIDTH + (this.props.show_tree ? CLASSIC_WIDTH : 0) + 6
      });
    }
  }
  
  
  
  componentDidMount() {
    this.update_total();
    this.set_position();
  }
  
  
  
  componentDidUpdate(prevProps: T_MenuBookProps, prevState: T_MenuBookState) {
    if (this.props.show_tree !== prevProps.show_tree) {
      this.set_position();
    }
  }
  
  
  
  change_include_mav_book = (ev: SyntheticEvent<*>, include_mav_book: boolean): void => {
    this.props.app.setState({include_mav_book}, this.update_total);
  };
  
  
  
  change_include_mt_book = (ev: SyntheticEvent<*>, include_mt_book: boolean): void => {
    this.props.app.setState({include_mt_book}, this.update_total);
  };
  
  
  
  change_mapnik_method = (ev: SyntheticEvent<*>, fast_method: boolean): void => {
    this.props.app.setState({
      mapnik_method: (fast_method ? 'near' : 'bilinear')
    });
  };
  
  
  
  start_book = (): void => {
    if (this.state.date1 !== 'NO' && this.state.date2 !== 'NO' && (this.state.date1 > this.state.date2)) {
      return Alert.error('El rango de fechas no es válido.');
    }
    
    let d1 = 'NO',
        d2 = 'NO';
    
    if (this.state.date1 !== 'NO') {
      const date1 = new Date(this.state.date1);
      
      date1.setUTCHours  (0);
      date1.setUTCMinutes(0);
      date1.setUTCSeconds(1);
      
      d1 = date1.toJSON();
    }
    
    if (this.state.date2 !== 'NO') {
      const date2 = new Date(this.state.date2);
      
      date2.setUTCHours  (23);
      date2.setUTCMinutes(59);
      date2.setUTCSeconds(59);
      
      d2 = date2.toJSON();
    }
    
    this.props.app.start_book(this.state.font_size, this.props.app.state.mapnik_method, d1, d2);
  };
  
  
  
  cancel = (): void => {
    this.props.app.setState({show_config_book: false});
  };
  
  
  
  change_font_size = (ev: SyntheticInputEvent<*>): void => {
    this.setState({font_size: parseInt(ev.target.value, 10)});
  };
  
  
  
  set_date1 = (unused: Object, date1: Date): void => {
    this.setState({
      date1: date1.toJSON()
    });
  };
  
  
  
  set_date2 = (unused: Object, date2: Date): void => {
    this.setState({
      date2: date2.toJSON()
    });
  };
  
  
  
  es_climasense = (): boolean => {
    return this.props.dir.toLowerCase().indexOf('climasense') !== -1;
  };
  
  
  
  render() {
    return (
      <div className='book_cfg' style={{left: this.state.left}}>
        <p>
          Incluir:
        </p>
        
        <div className='cfg_book_mav'>
          <Toggle
            label='Mapas de aplicación variable (MAV)'
            labelPosition='right'
            toggled={this.props.include_mav_book}
            onToggle={this.change_include_mav_book}
          />
        </div>
        
        <div className='cfg_book_mt'>
          <Toggle
            label='Mapas Temáticos (MT)'
            labelPosition='right'
            toggled={this.props.include_mt_book}
            onToggle={this.change_include_mt_book}
          />
        </div>
        
        <div className='cfg_book_method'>
          <Toggle
            label='Escalado rápido'
            labelPosition='right'
            toggled={this.props.mapnik_method === 'fast'}
            onToggle={this.change_mapnik_method}
          />
        </div>
        
        <div className='book_font_size'>
          Tamaño de la fuente:
          <input type='number' min={6} max={36} value={this.state.font_size} onChange={this.change_font_size} />
        </div>
        
        {this.es_climasense() &&
          <div className='book_dates'>
            Desde: <DatePicker hintText='El principio' hideCalendarDate={true} DateTimeFormat={DateTimeFormat} locale='es' mode='landscape' onChange={this.set_date1} id='bk_date1' />
            Hasta: <DatePicker hintText='El final'     hideCalendarDate={true} DateTimeFormat={DateTimeFormat} locale='es' mode='landscape' onChange={this.set_date2} id='bk_date2' />
          </div>
        }
        
        <div className='total_screenshots'>
          <LeftRight
            left={
              <span>
                Total de mapas: {this.state.map_total}
              </span>
            }
            
            right={
              this.props.building_doc ?
                <span>
                  Espere…
                </span>
              :
                <div>
                  <span className='book_cfg_cancel' onClick={this.cancel}>
                    Cancelar
                  </span>                  
                  
                  <span className='book_cfg_crear' onClick={this.start_book}>
                    Crear
                  </span>
                </div>
            }
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/MenuBook.jsx